import {LngLat, LngLatLike} from 'mapbox-gl';
import {z} from 'zod';

import {lngLatSchema} from './lngLatSchema';

export const lngLatLikeSchema = z.custom<LngLatLike>((lngLatLike: unknown) => {
    if (lngLatLike instanceof LngLat) {
        return true;
    } else if (typeof lngLatLike === 'object' && lngLatLike !== null) {
        const {lng, lon, lat} = lngLatLike as Record<string, unknown>;
        return lngLatSchema.safeParse([lng ?? lon, lat]).success;
    } else if (Array.isArray(lngLatLike)) {
        return lngLatSchema.safeParse(lngLatLike).success;
    } else {
        return false;
    }
});
